import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SavedDashboardHOC from '@components/common/SavedDashboardsHOC';
import { setSaving } from '@store/trends/dashboard/actions';
import { setCurrentActiveDashboard, createSavedDashboard } from '@store/tempDashboard/actions';
import { currentMetricsMetaSelector } from '@store/common/selectors';
import { sanitizeUserDefinedMetrics } from '@src/utils/metrics/userDefinedMetricsUtils';
import { isAppModule, CURRENT_PRODUCT_MODE } from '@utils/constants';
import { updateRollingIntervalForTrends } from '@utils/dashboard/rollingWindow';
import initStore from '../TrendsSharing/initStore';
import AppMain from '../AppExperience/index';
import Main from '../main/Main';

const RenderPage = {
  EI: Main,
  AI: Main,
  APP: AppMain,
}[CURRENT_PRODUCT_MODE];

function TrendsSavedDashboard(props) {
  const dispatch = useDispatch();
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const applySavedDataFromTrends = (payload) => {
    // update interval based on rolling flag and shortcut
    updateRollingIntervalForTrends(payload);
    dispatch(setCurrentActiveDashboard(payload));
    if (isAppModule) {
      const state = payload.config?.state || {};
      const sanitizedState = sanitizeUserDefinedMetrics(state, currentMetricsMeta);
      payload.config = {
        ...payload.config,
        state: sanitizedState,
      };
    }
    dispatch(setSaving(payload));
    dispatch(
      createSavedDashboard(payload.id, payload.name, payload.dashboardType.id, payload.config),
    );
  };

  // clear current active dashbaord.
  useEffect(() => {
    return () => {
      dispatch(setCurrentActiveDashboard(undefined));
    };
  }, []);

  return (
    <SavedDashboardHOC {...props} applySavedData={applySavedDataFromTrends} initStore={initStore}>
      {(props) => <RenderPage {...props} />}
    </SavedDashboardHOC>
  );
}

export default TrendsSavedDashboard;
